<template>
    <div>
        <el-alert
    :title="hidePhoneNum"
    type="success"
    description="已登录"
    close-text="退出登录"
    @close="loginOut"
    show-icon>
  </el-alert>
    </div>
</template>
<script>
import axios from 'axios';
import config from './config.js';
export default {
    data() {
        return {
            'phone_num': ''
        }
    },
    created() {
    	this.checkLogin()
    },
    computed: {
    	hidePhoneNum() {
    		let phone_num = this.phone_num
    		phone_num = phone_num.split('')
    		for(let i=0; i < phone_num.length; i ++){
    			if(i>2 && i < 7){
    				phone_num[i] = '*'
    			}
    		}

    		return phone_num.join('');
    	}
    },
    methods: {
        checkLogin() {
            let url = config.base_url + '/yun_table/users/islogin';
            axios.get(url, {
                headers: {
                    "Authorization": localStorage.getItem('token')
                }
            }).then((response) => {
                let res = response.data;
                if(res.login){
                    //console.log('login true');
                    let phone_num = localStorage.getItem('phone_num')
                    this.phone_num = phone_num

                }else{
                    //console.log('login false');
                    this.$router.push({
                        'path': '/login'
                    })
                }
            })

            
        },
        loginOut(){
        	
               localStorage.clear();
                this.$router.push({
                	path: '/login'
                })

        }
    }
}
</script>